/**
 * @author: lv.chen
 * @date: 2025/11/17
 * @desc: CasualGamesHub/KeyGames页面
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import ReusePageTemplate from '@intelligence/v3/components/ReusePageTemplate';
import ActiveUsers from '@intelligence/v3/pages/TopCharts/MobileGames/ActiveUsers';

interface IKeyGamesProps extends IBaseProps {}

const KeyGames: React.FC<IKeyGamesProps> = (props) => {
  const { style, className } = props;

  const { formatMessage } = useIntl();

  return (
    <ReusePageTemplate
      style={style}
      className={classnames('dbi-reuse-page-key-games', className)}
      title={formatMessage({ id: 'dbi_reuse_page_title_key_games' })}
      subTitle={
        <span dangerouslySetInnerHTML={{ __html: formatMessage({ id: 'dbi_reuse_page_sub_title_key_games' }) }}></span>
      }
    >
      <ActiveUsers
        pageLogConfigKey="casualGamesHubKeyGames"
        downloadLogConfigKey="casualGamesHubKeyGamesDownloadClick"
      />
    </ReusePageTemplate>
  );
};

export default KeyGames;
